import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import { ALERT_TYPE_INFO } from 'UIComponents/alert/AlertTypes';
// @ts-expect-error not typed yet
import { setHasSeenAnnouncementBanner } from 'ContentEditorUI/redux/actions/settingsActions';
// @ts-expect-error not typed yet
import { getHasSeenAnnouncementBanner } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { hasCurrentTimePassedDateToShowAgain } from 'ContentEditorUI/utils/announcementBannerUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const AnnouncementBanner = ({
  bannerKey,
  children,
  consumerName,
  titleText,
  shouldPersistSeenState = true,
  showAgainAfterDates,
  alertType = ALERT_TYPE_INFO
}) => {
  const dispatch = useDispatch();
  const [isDismissed, setIsDismissed] = useState(false);
  const hasSeenAnnouncementBanner = useSelector(state => getHasSeenAnnouncementBanner(state, {
    bannerKey,
    consumerName
  }));
  const shouldShowAgain = useMemo(() => {
    return !hasSeenAnnouncementBanner || hasCurrentTimePassedDateToShowAgain({
      lastSeen: hasSeenAnnouncementBanner,
      showAgainAfterDates
    });
  }, [hasSeenAnnouncementBanner, showAgainAfterDates]);
  const dismissBanner = useCallback(() => {
    if (shouldPersistSeenState) {
      dispatch(setHasSeenAnnouncementBanner({
        bannerKey,
        consumerName
      }));
    }
    setIsDismissed(true);
  }, [bannerKey, consumerName, dispatch, shouldPersistSeenState]);
  if (isDismissed || shouldPersistSeenState && !shouldShowAgain) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: alertType,
    titleText: titleText,
    closeable: true,
    onClose: dismissBanner,
    children: children
  });
};
AnnouncementBanner.propTypes = {
  bannerKey: PropTypes.string.isRequired,
  children: PropTypes.node,
  consumerName: PropTypes.string.isRequired,
  titleText: PropTypes.node.isRequired,
  alertTypes: PropTypes.string
};
export default AnnouncementBanner;